export default {
  API: 'http://localhost:5000'
}